document.addEventListener('click', function (e) {
  const legalGuaranteeLink = e.target.closest('a[href$="#garanzia-legale"]');

  if (legalGuaranteeLink) {
    e.preventDefault();

    const pdfCodeByLanguage = {
      bg: 'BGN',
      cs: 'CSN',
      da: 'DAN',
      de: 'DEN',
      el: 'ELN',
      en: 'ENN',
      es: 'ESN',
      et: 'ETN',
      fi: 'FIN',
      fr: 'FRN',
      ga: 'GAN',
      hr: 'HRN',
      hu: 'HUN',
      it: 'ITN',
      lt: 'LTN',
      lv: 'LVN',
      mt: 'MTN',
      nl: 'NLN',
      pl: 'PLN',
      pt: 'PTN',
      ro: 'RON',
      sk: 'SKN',
      sl: 'SLN',
      sv: 'SVN',
    };
    const language = document.documentElement.lang.toLowerCase().split('-')[0];
    const pdfCode = pdfCodeByLanguage[language] || pdfCodeByLanguage.it;
    const pdfFilename = `Legal guarantee_notice ${pdfCode}.pdf`;
    const pdfUrl = `https://garanzia-legale.s3.eu-south-1.amazonaws.com/${encodeURIComponent(pdfFilename)}`;

    window.open(pdfUrl, '_blank', 'noopener,noreferrer');
    return;
  }

  const link = e.target.closest('a[href$="#impostazione-cookie"]');
  if (!link) return;

  e.preventDefault();

  if (
    window.privacyBanner &&
    typeof window.privacyBanner.showPreferences === 'function'
  ) {
    window.privacyBanner.showPreferences();
  } else {
    console.warn('privacyBanner non disponibile');
  }
});
